/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import ReactDom from 'react-dom';
import { ModalProps } from 'types/components/Modal';
import ModalTitle from './ModalTitle';
import ModalMessage from './ModalMessage';
import ModalButtons from './ModalButtons';
import ModalBodyButtons from './ModalBodyButtons';
import ModalNotification from './ModalNotification';

export default React.memo(
  ({
    avatar,
    buttons,
    bodyButtons,
    customClassName,
    iframeUrl,
    isShowing,
    message,
    setIsShowing,
    subtitle,
    title,
    titleIcon,
    children,
    isFullscreen,
    hasCloseIcon,
    notification,
  }: ModalProps) => {
    const renderModal = () => {
      return (
        <div id="Modal_container" className={`dialog ${iframeUrl !== undefined ? 'iframeModal' : ''}`}>
          <div className={`dialog-content ${buttons ? '' : 'no-action-buttons'}`}>
            <div className={`modal-container ${customClassName || ''}`}>
              <ModalTitle
                title={title}
                titleIcon={titleIcon}
                avatar={avatar}
                subtitle={subtitle}
                closeModal={hasCloseIcon && setIsShowing ? () => setIsShowing(false) : undefined}
              />
              <ModalMessage message={message} />
              <ModalBodyButtons bodyButtons={bodyButtons} />
              <ModalButtons buttons={buttons} />
              {children || (iframeUrl && <iframe title="vodafone" src={iframeUrl} />)}
              {notification && (
                <ModalNotification
                  text={notification.text}
                  onClose={notification.onClose}
                  duration={notification.duration}
                />
              )}
            </div>
          </div>
          <div
            className={`dialog-overlay ${notification ? 'no-background' : ''}`}
            onClick={setIsShowing ? () => setIsShowing(false) : undefined}
          />
        </div>
      );
    };

    if (isShowing) {
      let modal = null;
      if (isFullscreen) {
        modal = renderModal();
      } else {
        const portal = document.getElementById('portal');
        modal = portal ? ReactDom.createPortal(renderModal(), portal) : null;
      }
      return modal;
    }

    return null;
  }
);
